import styled from 'styled-components'
import { device } from 'src/common/theme/mediaQueries'

export const StyledLoginWrapper = styled.div`
    align-items: center;
    background-color: ${props => props.theme.main.colors.backgroundLight};
    display: flex;
    min-height: 100vh;
    justify-content: center;
`

export const StyledLogin = styled.div`
    .logo-wrapper {
        margin: 0 auto 20px;
        max-width: 150px;
        
        img {
            height: 100%;
            object-fit: contain;
            width: 100%;
        }
    }
    
    .notification {
      margin: 0 auto;
      a {
        text-decoration: underline;
      }
    }
    
    h3 {
        color: ${props => props.theme.main.colors.secondaryColor};
        font-family: ${props => props.theme.main.fonts.secondaryFontFamily};
        font-size: 30px;
        text-align: center;
        text-transform: uppercase;
    }
    
    .login-header {
        margin-bottom: 30px;
    }
    
    .login-body {
    
        .body-left,
        .body-right {
            padding: 0 0 1.5rem;
            width: 50%;
        }
        
        .body-left {
            border-right: 1px solid ${props => props.theme.main.colors.inputBorderColor};
            padding-right 2.8rem;
        }
        
        .body-right {
            display: flex;
            flex-direction: column;
            padding-left: 2.8rem;
            
            .btn-wrapper {
                display: flex;
                justify-content: center;
            }
        }
    }
    
    @media ${device.tabletL} {
        
        .login-body {
        
            .body-left {
                padding-right: 1.7rem;
            }
            
            .body-right {
                padding-left: 1.7rem;
            }
        }
        
        h3 {
            font-size: 26px;
        }
    }
    
    @media ${device.tablet} {
    
        .login-header {
            margin-bottom: 20px;
        }
    }
    
    @media ${device.mobileL} {
        .login-body {
            flex-direction: column;
            
            .body-left, .body-right {
                padding: 0;
                width: 100%;
            }
            
            .body-left {
                border: 0;
                border-bottom: 1px solid ${props => props.theme.main.colors.inputBorderColor};
                padding-bottom: 30px;
            }
            
            .body-right {
                padding-top: 25px;
                
                h3 {
                    margin-bottom: 0;
                }
            }
        }
    }
`
